import { render, staticRenderFns } from "./goal-list.vue?vue&type=template&id=79289110&"
import script from "./goal-list.vue?vue&type=script&lang=ts&"
export * from "./goal-list.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports